import layoutMosaic, { type MosaicRect } from "@ext/markdown/elements/gallery/logic/layoutMosaic";

const MOSAIC_WIDTH = 1000;
const MOSAIC_SPACING = 3;

export const GALLERY_CELL = "[data-gallery-items] > :is([data-gallery-cells], [data-node-view-content-react]) >";

const percent = (value: number, total: number) => `${+((value / total) * 100).toFixed(4)}%`;

const RADIUS = "var(--gallery-radius)";

const cornerRadius = ({ x, y, width, height }: MosaicRect, boxWidth: number, boxHeight: number) => {
	const left = x === 0;
	const top = y === 0;
	const right = x + width >= boxWidth;
	const bottom = y + height >= boxHeight;
	const corner = (touches: boolean) => (touches ? RADIUS : "0");
	return [corner(top && left), corner(top && right), corner(bottom && right), corner(bottom && left)].join(" ");
};

const layout = (ratios: number[]) => layoutMosaic(ratios, { width: MOSAIC_WIDTH, spacing: MOSAIC_SPACING });

export const getMosaicScale = (ratios: number[]) => percent(layout(ratios).width, MOSAIC_WIDTH);

export const getMosaicAspectRatio = (ratios: number[]) => {
	const { width, height } = layout(ratios);
	return height ? width / height : undefined;
};

const getMosaicStyles = (scope: string, ratios: number[]) => {
	const { width, height, items } = layout(ratios);

	return [
		`${scope} [data-gallery-items] { width: calc(100% * var(--gallery-scale, 1)); aspect-ratio: ${+(width / height).toFixed(4)}; }`,
		...items.map(
			(item, index) =>
				`${scope} ${GALLERY_CELL} :nth-child(${index + 1}) { left: ${percent(item.x, width)}; top: ${percent(item.y, height)}; width: ${percent(item.width, width)}; height: ${percent(item.height, height)}; border-radius: ${cornerRadius(item, width, height)}; }`,
		),
	].join("\n");
};

export default getMosaicStyles;
